<template>
  <div>
      <!-- <router-view /> -->
      <!-- <van-tabbar v-model="$route.meta.activeNum"> -->
      <van-tabbar v-model="active" active-color="#1989fa" inactive-color="#656466" @change="onChange">
          <van-tabbar-item to="/index" icon="home-o">首页</van-tabbar-item>
          <van-tabbar-item to="/course" icon="label-o">选课</van-tabbar-item>
          <van-tabbar-item to="/learning" icon="play-circle-o">学习</van-tabbar-item>
          <van-tabbar-item to="/Question" icon="edit">题库</van-tabbar-item>
          <van-tabbar-item to="/user" icon="user-o">我的</van-tabbar-item>
      </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'AppTabbar',
  data () {
    return {
	    active:0,
    }
  },

  //通过这个获取到网页的路径 ps:this.$route(只读)，this.$router(跳转)
  mounted() {
    console.log(this.$route.path);
  },
	watch: {
		$route(to, from) {
			this.active = to.meta.activeNum;
		}
	},
  methods:{
    onChange(){},
    chang(){}
  },

}
</script>
 
<style lang = "less" scoped>

</style>